module.exports = __webpack_public_path__ + "img/logo-regione-single.1218762e.png";